export default __webpack_public_path__ + "locales/en/Ldap.json?hash=665b8985ccaaca185e371976822067ce";